


























import Vue from 'vue';
import { mapGetters } from 'vuex';
import StudioProductCard from '@/web/components/products/StudioProductCard';

export default Vue.extend({
  name: 'StudioProductIncludedProducts',
  components: { StudioProductCard },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
    }),
    searchedBundledProducts() {
      if (!this.search) return this.product.bundled_products;
      return this.product.bundled_products.filter(
        product =>
          product.product_name
            .toUpperCase()
            .indexOf(this.search.toUpperCase()) !== -1
      );
    },
  },
  methods: {
    getProductPath(product) {
      return this.product.purchased || this.product.owned
        ? {
            name: 'studio-product',
            params: { product_id: product.id },
          }
        : {
            name: 'studio-bundled-product',
            params: { product_id: product.id, bundle_id: this.product.id },
          };
    },
  },
});
